import { render, staticRenderFns } from "./UploadHistoryButton.vue?vue&type=template&id=20b6882a"
import script from "./UploadHistoryButton.vue?vue&type=script&lang=ts"
export * from "./UploadHistoryButton.vue?vue&type=script&lang=ts"
import style0 from "./UploadHistoryButton.vue?vue&type=style&index=0&id=20b6882a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports